import { Repository } from "src/firebase/firestore/repository";
import { Lounge } from "./types/lounge.entity";

class LoungeRepository extends Repository<Lounge> {
  constructor() {
    super("lounge_requests");
  }
}

export const loungeRepository = new LoungeRepository();
